export const LogoMark = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    className={className}
    data-testid="logo-mark"
    aria-hidden="true"
  >
    <circle cx="32" cy="32" r="29" stroke="#D4AF37" strokeWidth="1.5" />
    <circle cx="32" cy="32" r="21" stroke="#D4AF37" strokeOpacity="0.4" strokeWidth="1" />
    {[0, 45, 90, 135, 180, 225, 270, 315].map((a) => (
      <ellipse
        key={a}
        cx="32"
        cy="19"
        rx="4.5"
        ry="11"
        stroke="#D4AF37"
        strokeWidth="1"
        transform={`rotate(${a} 32 32)`}
      />
    ))}
    <circle cx="32" cy="32" r="3.5" fill="#D4AF37" />
  </svg>
);
